<template>
    <div>
        <div class="informationList" >

            <div class="dataItem bottomBorderF5F5F5" v-for="dataItem in dataList" :key="dataItem.id"
                 style="margin-bottom: 20px; padding: 0 4px 20px 24px; ">

                <div class="flexLayout">
                    <div style="width: 40px; margin-right: 12px;">
                        <div class="imageArea" style="width: 100%; height: 40px;" @click.stop="viewUser(dataItem)">
                            <img class="fullSpace circle" v-if="dataItem.userInfo" :src="dataItem.userInfo.headerImg"/>
                        </div>
                    </div>
                    <div class="flexItem">
                        <div>
                            <span class="f14" @click.stop="viewUser(dataItem)">{{ dataItem.userInfo.userName }}</span>
                            <span class="color8A8A8A fr f13">{{ formatDelayTime(dataItem.createTime) }}</span>
                        </div>
                        <div class="colorA9ABAE f12">
                            {{ dataItem.userInfo.signature || '' }}
                        </div>
                    </div>
                </div>

                <div class="titleArea marginT12 color101010 font14r bold hiddenOverflow"
                     style="max-height: 96px; line-height: 24px;" @click="viewItem(dataItem)">
                    <div class="marginR4">{{ plainTextToHtml(dataItem.content) }}</div>
                    <!--                            <i class="icon newIcon relative" style="top: 6px;" v-if="isToday(dataItem.createTime)"></i>-->

                </div>

                <div class="marginT8" v-if="dataItem.imgList.length">
                    <img :src="dataItem.imgList[0]" style="max-width: 186px; height: auto;" v-gallery="imageGroup" />
                </div>

                <div class="imageContainer2 marginT8 clearfix" :class="{ 'moreThanThree' : dataItem.imgList.length > 3 }"
                     v-if="dataItem.imgList.length">
                    <div class="imageItem roundBorder4" v-for="(imageItem, index) in dataItem.imgList.filter((value,index) => index < 2 )" style="height: 113px;overflow:hidden">
                        <img class="fullSpace cover" :src="imageItem" v-gallery="imageGroup" style="width:100%;height:auto"/>
                        <div class="imageCaption white alignC" v-if="index == 2 && dataItem.imgList.length > 3">
                            +
                            <strong class="bold font18r">{{ dataItem.imgList.length - 3 }}</strong>
                        </div>
                    </div>
                </div>

                <div class="marginT8 relative" v-if="dataItem.videoCover" @click="viewItem(dataItem)">
                    <img :src="dataItem.videoCover" style="max-width: 100%; height: auto;"/>
                    <div class="playIcon2" style="
                                    z-index: 1 ;
                                    position: absolute;
                                    top: 50%;
                                    left: 50%;
                                    height: 84px;
                                    width: 84px;
                                    margin-left: -42px;
                                    margin-top: -42px;">
                    </div>
                </div>

                <!--                        <div class="font12r clearfix marginT20" style="line-height: 24px; padding-left: 10px; padding-bottom: 16px;">-->
                <!--                            <div class="floatL">-->
                <!--                                <img class="size24 circle fl marginR4" :src="dataItem.headerImg">-->
                <!--                                <span class="font12r" style="color: hsla(219, 9%, 39%, 1)">-->
                <!--                                    {{dataItem.userName}}-->
                <!--                                </span>-->
                <!--                            </div>-->
                <!--                            <span class="color777 marginL16">-->
                <!--                                {{formatDate(dataItem.createTime)}}-->
                <!--                            </span>-->
                <!--                            <div class="fr orange" style="padding-right: 12px;">-->
                <!--                                <i class="icon eyeIcon fl marginR4"></i>-->
                <!--                                &lt;!&ndash; 浏览量：真实值+虚拟值 &ndash;&gt;-->
                <!--                                {{dataItem.pv + dataItem.pvSham}}-->
                <!--                            </div>-->
                <!--                        </div>-->

                <div class="flexLayout alignC font12r" style="margin-top: 30px; color: #A9ABAE; line-height: 24px;"
                     @click="viewItem(dataItem)">
                    <div class="flexItem">
                        <i class="icon shareIcon size24 alignM"></i>
                        分享
                    </div>
                    <div class="flexItem">
                        <i class="icon commentIcon size24 alignM"></i>
                        {{ dataItem.commentCount }}
                    </div>
                    <div class="flexItem">
                        <i class="icon praiseIcon size24 alignM" :class="{active : dataItem.isPraise}"></i>
                        {{ dataItem.praiseCount }}
                    </div>

                </div>

            </div>
        </div>

        <div class="alignCenter paddingV8" v-show="status === 'loading'">
            <i class="icon spinner-loader"></i>
        </div>

        <div class="paddingV16 colorCCC font14r alignC"
             v-show="status == 'ready' &&  dataList.length < 1">
            暂无任何记录
        </div>

        <div class="paddingV16 alignCenter font14r colorCCC"
             v-show="status=='ready' && pagination.current == pagination.totalPage"
             :data-current="pagination.current" :data-total="pagination.totalPage || 0">
            没有更多记录了
        </div>

        <div class="paddingV16 colorCCC font14r alignC"
             v-show="status == 'error'">
            加载数据失败
        </div>
    </div>

</template>

<script>
import generalCmpPart from "@comp/part/generalCmpPart";

// config
import appConfig from '@/appConfig';

// util
import appHelper        from '@/util/appHelper';
import dataMixedUtils   from "@/util/dataMixedUtils";

const config = {
    apiConfig : {
        list : {
            url : 'portal/moment/list',
            params : {
                type : 1
            },
            dataPath : 'data.records',
            totalPagePath : 'data.pages'
        }
    },
};

export default {
    extends : generalCmpPart,
    components : {  },
    props : {
        userId : String
    },
    data () {
        return {
            apiConfig : config.apiConfig,

            // pageSize : 8,
            enableDataList : true,

            imageGroup : 'imageGroup',
        }
    },
    methods : {
        viewItem(dataItem) {
            appHelper.goToPage('informationDetail', {
                id : dataItem.id
            });
        },
        viewUser(dataItem) {
            appHelper.goToPage('informationUser', {
                id : dataItem.userInfo.userId
            });
        },
        plainTextToHtml(text) {
            return dataMixedUtils.html.nlToBr(text);
        }
    },
    mounted() {

        if (this.userId)
        {
            this.apiConfig.list.params = {
                userId : this.userId
            }
        }
        this.loadDataList();

        if (appConfig.mode == 'demo')
        {
            this.dataList = dataMixedUtils.array.buildDataList(8, (index) => {

                let item = {
                    id : index,
                    content : dataMixedUtils.array.getRandomItem(config.demoTitleList),
                    type : dataMixedUtils.number.getRandomInteger(2),
                    coverImg : appHelper.getRandomCoverImage(),
                    userInfo : {
                        userId : 1,
                        headerImg : appHelper.getRandomCoverImage(),
                        userName : dataMixedUtils.string.getRandomNickName(),
                        signature : '杭州创业小公司产品经理'
                    },
                    createTime : new Date().getTime() - dataMixedUtils.number.getRandomInteger(1000 * 60 * 60 * 24 * 7),
                    imgList : [],
                    videoCover : '',
                    video : null,
                    commentCount : dataMixedUtils.number.getRandomInteger(20),
                    praiseCount : dataMixedUtils.number.getRandomInteger(200),
                };
                if (dataMixedUtils.number.getRandomInteger(2) == 1)
                {
                    item.videoCover = appHelper.getRandomCoverImage();
                }
                else
                {
                    item.imgList = dataMixedUtils.array.buildDataList(dataMixedUtils.number.getRandomInteger(6), (index) => {
                        return appHelper.getRandomCoverImage();
                    });
                }
                return item;
            });
        }
    },
    watch : {
        userId() {
            this.apiConfig.list.params = {
                userId : this.userId
            };
            this.reloadDataList();
        }
    }
}
</script>

<style lang="scss" scoped>
.shareIcon {
    background-image: url('data:image/png;base64,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');
}
.commentIcon {
    background-image: url('data:image/png;base64,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');
}
.praiseIcon {
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAFVUlEQVRoQ+2Za2hbZRjHl/QSrWiztVu3bvOLzPplMFBxMKYi2+iXffGDoqKzINWkbdrazHpDM1GndaZ3O6tClKKDMhQRZN6KDKZDmUwHw32oOG3rZVkaiyUlN39POae8TU4unck5GSxw6M55n/d9/v/n+b/Pe5lt1WX+s13m+FddIWB1BouaAZ/PZ5+dnX0IkpuTyeSv8Xj8+NDQ0C+FJF00Am1tbdvtdvtRm81WrwCOQWSwv7//8UKRKAqBjo4OJ0DPAn59BqAH+vr6fIUgUSwCAu55DaAPIm8jnxv5KxlZDbmFRCKxbnBw8J//S6IoBNrb278G6O2A+55I36qD7Ozs3AX4z+UdAq6BgYHDpUrgHAS2APYT9L5XBYm8pnnfQNs7tD1SqgQiEHAA7gMycL8Kkux8RttuCByDQGPJEaD6bCorK/tNgAGyN7XikIH3abqPtpO0bS85AgBsAdSQBqyJDARSJCTv+0qZwA8A3AbAJBP1eirN7ykSOoKE7qV5ggzcVVIZ8Hg8jSxen2ryMQTIHPgGAiKdANlpKhkCra2t9eXl5d8CaLNG4B4iPK4C7O7uro5EIiEISPneD4FDJUEA3UtZnABXgwb+S8DvSgWH3QN8G5PvyGsH68AJywkgm5sB/hHPJg3M6crKyp09PT1zBgQm+HYnz79TU1PV4+PjcUsIaLvM26Qc8kjVsWuRP0lk9xhtEZDYTUjsrAZYyJ3KE3ycMcdmZmbeMyJsuJUgqluYjBsVB3b0+hU13sH3ANGWBcipAkBCR8LhcFMgEIgYAUM+suq+lSdoI7NT8/PzO0dHR+fVxjQCVAk/ADtTwEVjsdgGwEdZpMIpbWd496L5Y9nAsQ/aCMlXsdGlli+XNRhu1YwPEsinsxIgUn9jUJsy+qTT6WwIBoNVOgHA/Ayh53p7e6XSJPNFcyl2KOIxfI3gMzg9PV2nSiktAxAI4mQNxoeJqkt1iISu0wkw4Da/33/6UgCttI9Woqe0fvVkYUYfIyMBDEYwdKvOpI4vLCzMyjczCSC/PbL50/w2ELhzOQnQ4Q0yIBVm6ScnLV5CZhPArw+fckCKIeWrqYKxnAQwGCYDrSoBl8u12uFwXLSAgERfsnCCoO7IOompQhe1Y98Qxm2qMamUuSFzxDQJaWuOyPZankMEdX9eBDAaxNijGnd1ddVytpUqZRoBgraVoP0oPlnQ7mb78WFeBOg0QAbaVWOq0Fqq0F8mE2gGy5viMxqN1g4PDy8qIOMc0CWEQT8Z6FCNvV7vOha0P80kwAQO4G8fzyR4blDxyL+NVuLFOUAb9n3LVmTI1dH2h5kE8KlfEIyhiAfzJmB0nnW73evZaS4uImasAy0tLTUVFRUXNNBuAjqSkwApkzovN2uvw9irdjCbABN4Lzg+zhYwo5V4kQBPWskyW0L4O4hknwTLHAuYk5KaWEkGXiMDT6gdLCCg3/B9gXx2p4I3nMS6hGjsoVO3VQSIdnkoFJojA1choxcIpn7XuoxHRgnJ3p1Okr6ln5kZQP+3gOE7cc7fxkznDSMCsmxX0+kVOj1lFQGC5SH6/fhPUPmcRmfsTBJaJMCTdvoxMwP40i/AzhBI/USWNg2yZeBlOj5jVQaYi+fxLXdMo8zFR40mcK4MvETHZ60goN8fyfUkC+YdHFuP501A2Qupfd6FzMOqhDINWODvPvweyDamkYT0yye13wXWkTrK2lp9L1RgoMuGI/By/fgi4P25/KQRYMd5DXt+KWFLbQx2njRONjc3V1RVVS07EeVysNJ2fIdramp+Uo+NK8rASh1abV+U/+Qzk9QVAmZG28jXf1bW3k/80G2uAAAAAElFTkSuQmCC');

    &.active {
        background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAELklEQVRoQ+2ZTYwUVRCAq940rrqykNnp150Y4xHUaDiIcgA0IXogGw8aCULEgMaVnV4S9QghEPSkyRp2ehVEovwsGk0IIcQDCfHnBJJ4kCh4NP7M655hWVCBne0ui5/ByWz3dM9P78wk26fdvHr16ntVr6reG4Qu/7DL7Yc5gHZ7cNY84IzpK4BSmxj4PoH+sf6McwTXgNfsBswKgJsz1hLAYUAUFQb/iP70gD5c+LMZiMQBaAcIVzcuAeD8akOJ6CfZq57AjXCtUYjEAdzRzOMktB/CDGTP7DKy+e0dC6By8mWOnAOhBhJd0ucpiYNQagQicQ+onLkTEWrvMHor5ZD7fUcCODnzBFeb1TWNI7Cklbc7DmByX1/6+rV7FGcfrTYAfSAt9WbHATi2sZWzzzuRhpFvS8uxIuUCBBI7A1c+NORVH35lgAVRhnEm+ogz0eYouaDxxABixf5tixhgJwPs6BgA15ZvE4j34xqERIO6pfbGla+Ua7kH1Kh8AQV+yaETWzdLPq0P5b9tO4AzZr4IPo1HZp0qS1Pe1AP9Wy7+3nIAIkDX1lcgpQRp3qQu3HNhFdO1jZduNmx17Pz/BtMXvNT5MABBdL4H/j3ZZ10pVsuEupl2Q48rjK/YnoGKhSaR4A2O188rFU2MLFw4ddfdf7CyexvZxVhziKYJaI1hOUdjnQHHNm9UxqGZysnTBCxJb1bnymPcLg8Q4vFYhjQjRHQZ0L9fZt2/y2pCPaBs85/QHSXaz5Xz1QqAtQxwpBnb4s4VPq3KDKtTNQFuFSFUYUq5jz9tWGrZHYCb8Y/jcY1oSo68p6TlflcTwLF1EyD1V+hCBGe5+Vp6B2DUWEcC+QAn/2na9QfTgxO/dSUAZ7kCV2w98hDX7QFbrufKeyj5/afjMqueazmAsuUGBPHZLABsY4B3Ww7AjdsrfGn5NGkAIv9ZrgMnuxaAW44F3HJc7laACzKbX1zt5cBCVu8hno0Q4r7soGHlN3QtAAK9rmfVx8kAjJkbgWB/kodY+KWHMsPFGR1ri0LI2MRd6ycJAkxw/KeD9HcFAPdeR7n3ej45ANvgzhT3JeUBjv+3OP5HuhfAn17Kz/BnEwPgC81rfB+YkSFa4RFOn0WOf50v/tzLzfwCz0CM+8AZjskny+qS7IWiHr3Cb2Q5s8DU/UHUfKjGGWB9eYwL33K+PzT0uhzlJQGlhzPZ4i9hcqEATs7YxqlxV+BE9Fbzc/jX5bFbv8KYP/P/i6IMqmecN+oUb9SqWnPCXyX2wDy3JEcYgi/2tx+puB3kv7cEPYVfHDUeLSF+w5KB+boew2/IcuxPpYBWZix1uiGA8qTi7nQfCO0Rn0RPSqNC5WtEteL8e0av1kvPeCSWsAWPIWJjMEQKhbddHypciAKP/fwXpahd43MA7dr58rpzHmi3B/4DtK3hQD4hTzcAAAAASUVORK5CYII=');
    }
}
</style>
